import { FC } from 'react';

type Props = {
  placeholder: string;
  buttonText: string;
  numericSearch?: boolean;
  handleChangeSearchTerm(event: React.ChangeEvent<HTMLInputElement>): void; // eslint-disable-line
  handleClickSearch: VoidFunction; // eslint-disable-line
};

const SearchModule: FC<Props> = ({
  placeholder,
  buttonText,
  numericSearch = false,
  handleChangeSearchTerm,
  handleClickSearch,
}) => (
  <div className="card-bordered p-2 d-flex justify-content-between w-100">
    <div id="searchModule" className="form-group flex-fill mb-0">
      <div className="form-control-wrap">
        <div className="form-icon form-icon-left">
          <em className="icon ni ni-search" />
        </div>
        <input
          type={numericSearch ? 'number' : 'text'}
          className="form-control bg-transparent border-light"
          placeholder={placeholder}
          onChange={handleChangeSearchTerm}
        />
      </div>
    </div>

    <button
      type="button"
      className="btn btn-primary"
      onClick={handleClickSearch}
    >
      {buttonText}
    </button>
  </div>
);

export default SearchModule;
